import {
  INVOICE_TASK_LIST_REQUEST,
  INVOICE_TASK_LIST_SUCCESS,
  INVOICE_TASK_LIST_FAIL,
  INVOICE_TASK_CREATE_REQUEST,
  INVOICE_TASK_CREATE_FAIL,
  INVOICE_TASK_CREATE_SUCCESS,
  INVOICE_TASK_GET_REQUEST,
  INVOICE_TASK_GET_FAIL,
  INVOICE_TASK_GET_SUCCESS,
  INVOICE_TASK_UPDATE_REQUEST,
  INVOICE_TASK_UPDATE_FAIL,
  INVOICE_TASK_UPDATE_SUCCESS,
  INVOICE_TASK_DELETE_REQUEST,
  INVOICE_TASK_DELETE_FAIL,
  INVOICE_TASK_DELETE_SUCCESS,
  INVOICE_TASK_REMINDER_OFF_REQUEST,
  INVOICE_TASK_REMINDER_OFF_SUCCESS,
  INVOICE_TASK_REMINDER_OFF_FAIL,
} from "../constants/taskConstants";
import api from "../core/api";

export const listInvoiceTask = (InvoiceId) => async (dispatch, getState) => {
  try {
    dispatch({ type: INVOICE_TASK_LIST_REQUEST });
    const { data } = await api.get(`/accounts/task/${InvoiceId}`);

    var dt = data.Result;

    if (typeof dt == "string") {
      dispatch({
        type: INVOICE_TASK_LIST_FAIL,
        payload: data.Result,
      });
    } else {
      dispatch({
        type: INVOICE_TASK_LIST_SUCCESS,
        payload: data.Result,
      });
    }
  } catch (error) {
    dispatch({
      type: INVOICE_TASK_LIST_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const createInvoiceTask =
  (invoiceJson) => async (dispatch, getState) => {
    try {
      dispatch({ type: INVOICE_TASK_CREATE_REQUEST });
      const { data } = await api.post(
        `/accounts/task`,
        invoiceJson
      );

      var dt = data.Result;

      if (dt.includes("Error")) {
        dispatch({
          type: INVOICE_TASK_CREATE_FAIL,
          payload: data.Result,
        });
      } else {
        dispatch({
          type: INVOICE_TASK_CREATE_SUCCESS,
          payload: data.Result,
        });
      }
    } catch (error) {
      dispatch({
        type: INVOICE_TASK_CREATE_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const getInvoiceTask = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: INVOICE_TASK_GET_REQUEST });
    const { data } = await api.get(`/accounts/task/${id}`);

    var dt = data.Result;

    if (typeof dt == "string") {
      dispatch({
        type: INVOICE_TASK_GET_FAIL,
        payload: data.Result,
      });
    } else {
      dispatch({
        type: INVOICE_TASK_GET_SUCCESS,
        payload: data.Result,
      });
    }
  } catch (error) {
    dispatch({
      type: INVOICE_TASK_GET_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const updateInvoiceTask =
  (invoiceJson, taskid) => async (dispatch, getState) => {
    try {
      dispatch({ type: INVOICE_TASK_UPDATE_REQUEST });
      const { data } = await api.put(
        `/accounts/task/${taskid}`,
        invoiceJson
      );

      var dt = data.Result;

      if (dt.includes("Error")) {
        dispatch({
          type: INVOICE_TASK_UPDATE_FAIL,
          payload: data.Result,
        });
      } else {
        dispatch({
          type: INVOICE_TASK_UPDATE_SUCCESS,
          payload: data.Result,
        });
      }
    } catch (error) {
      dispatch({
        type: INVOICE_TASK_UPDATE_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const deleteInvoiceTask = (taskid) => async (dispatch, getState) => {
  try {
    dispatch({ type: INVOICE_TASK_DELETE_REQUEST });
    const { data } = await api.get(`/accounts/task/${taskid}`);

    var dt = data.Result;

    if (dt.includes("Error")) {
      dispatch({
        type: INVOICE_TASK_DELETE_FAIL,
        payload: data.Result,
      });
    } else {
      dispatch({
        type: INVOICE_TASK_DELETE_SUCCESS,
        payload: data.Result,
      });
    }
  } catch (error) {
    dispatch({
      type: INVOICE_TASK_DELETE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const reminderInvoiceTask = (taskId) => async (dispatch, getState) => {
  try {
    dispatch({ type: INVOICE_TASK_LIST_REQUEST });
    const { data } = await api.get(`/accounts/task/${taskId}`);

    var dt = data.Result;

    if (dt.includes("Error")) {
      dispatch({
        type: INVOICE_TASK_REMINDER_OFF_FAIL,
        payload: data.Result,
      });
    } else {
      dispatch({
        type: INVOICE_TASK_REMINDER_OFF_SUCCESS,
        payload: data.Result,
      });
    }
  } catch (error) {
    dispatch({
      type: INVOICE_TASK_REMINDER_OFF_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};
